// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:37:05

export default {
  "id": "foot-hospital-1",
  "slug": "foot-hospital-1",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/a60fc1cb96ea457b85f8dbf17cb80898-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/a60fc1cb96ea457b85f8dbf17cb80898/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Foot Hospital",
      "description": "HELP! Doctor, I hurt my feet, ouch! It is so painful!Could you please help me to cure my feet? I know you have the best medical tools here!",
      "instructions": "Cure patient's feet",
      "genres": [
        "Care",
        "Simulation"
      ],
      "tags": [
        "doctor",
        "hospital",
        "surgery"
      ]
    },
    "zh-CN": {
      "title": "脚部医院",
      "description": "救命！医生，我的脚受伤了，好疼！太痛苦了！你能帮我治疗我的脚吗？我知道你们这里有很多最好的医疗工具！",
      "instructions": "治愈患者双脚",
      "genres": [
        "关怀",
        "模拟"
      ],
      "tags": [
        "医生",
        "医院",
        "手术"
      ]
    },
    "zh-TW": {
      "title": "腳醫院",
      "description": "幫助！醫生，我的腳受伤了，好痛啊！這好痛！請你幫我治療我的腳可以嗎？我知道你這裡有最好的醫療工具！",
      "instructions": "治療病患的腳",
      "genres": [
        "關心",
        "模擬"
      ],
      "tags": [
        "醫生",
        "醫院",
        "手術"
      ]
    },
    "zh-HK": {
      "title": "足醫院",
      "description": "救命啊！醫生，我腳受伤了，好痛啊！這真的很痛苦！請問你能幫我治療腳傷嗎？我知道你這裡有最好的醫療工具！",
      "instructions": "治療病患雙腳",
      "genres": [
        "關心",
        "模擬"
      ],
      "tags": [
        "醫生",
        "醫院",
        "手術"
      ]
    },
    "ja": {
      "title": "足病院",
      "description": "ヘルプ！医師さん、私の足が痛いです、あー痛いです！治療していただけますか？ここには最高の医療器具がありますから！",
      "instructions": "患者の足を治療する",
      "genres": [
        "ケア",
        "シミュレーション"
      ],
      "tags": [
        "医師",
        "病院",
        "手術"
      ]
    },
    "ko": {
      "title": "발병원",
      "description": "헬프! 의사님, 발이 아파요, 아이고! 너무 아파요! 발을 치료해 주실 수 있나요? 여기서 최고의 의료 도구가 있을 줄 알아요!",
      "instructions": "환자의 발을 치료하세요",
      "genres": [
        "주의",
        "시뮬레이션"
      ],
      "tags": [
        "의사",
        "병원",
        "수술"
      ]
    },
    "fr": {
      "title": "Hôpital des Pieds",
      "description": "HELP ! Docteur, j'ai mal aux pieds, ah ! Ça fait mal ! Pourriez-vous s'il vous plaît m'aider à guérir mes pieds ? Je sais que vous avez les meilleurs outils médicaux ici !",
      "instructions": "Guérir les pieds des patients",
      "genres": [
        "Prudence",
        "Simulation"
      ],
      "tags": [
        "docteur",
        "hôpital",
        "chirurgie"
      ]
    }
  }
};
